<template>
    <div id="MyProfileDiv">
      <HeaderVue />
      <div class="inner-page phleb-signup my-profile">
          <div class="container">
            <div class="row">
                <div class="col-sm-6 offset-sm-3">
                    <div class="sign-up">
                        <div class="signup-title">
                            <h4 class="mt-0 mb-0">My Account</h4>
                        </div>
                        <div class="row">
                            <div class="col-sm-5">
                                <div class="form-content line-textbox">
                                    <!--<div class="d-flex credit-box">
                                        <div class="testimonial-dp float-none">
                                            <img src="images/profile.jpg" class="img-fluid" alt="">
                                        </div>
                                    </div>-->
                                    <label>{{firstName + ' ' + lastName}}</label>
                                    <label>{{email}}</label>
                                    <label>{{phone1}}</label>
                                    <router-link to="/changepassword">Change Password</router-link>
                                    <div class="row mt-3">
                                        <div class="col-sm-12">
                                            <router-link to="/editprofile"><button class="btn btn-primary full-width">Edit</button></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-7">
                                <div class="form-content line-textbox">
                                    <div class="d-flex credit-box">
                                        <div class="credit-points">
                                            <div class="d-flex">
                                                <div class="credit-score">
                                                    <h1 class="m-0">{{creditPoint}}</h1>
                                                    <p>Credits</p>
                                                </div>
                                                <div class="referral-code">
                                                    <h4 class="mt-0">
                                                        <span class="badge badge-secondary">{{referralCode}}</span>
                                                    </h4>
                                                    <h6 class="mb-0">Your Referral Code</h6>
                                                </div>
                                            </div>
                                            <router-link to="/referral/invite"><button class="btn btn-sm btn-outline-primary mt-3 w-100">Refer & Earn</button></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-sm-4">
                    <div class="sign-up">
                        <div class="signup-title">
                            <h4 class="mt-0 mb-0">Referral Details</h4>
                        </div>

                    </div>
                </div> -->
            </div>
        </div>
          
      </div>
      <FooterVue />
      <div class="modal fade bd-example-modal-sm" id="inviteFriends" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Refer and earn credit points</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="mt-0">
                        Copy & share the link to your friends & family to earn Rs.{{credits}} worth of Labotist credits, when each referral completes an order through Labotist. Your friend or family member will also earn Labotist credits which they can immediately use.
                    </p>
                    <input type="text" class="copy-link" name="copyReferralText" ref="copyReferralText" id="copyReferralText" v-model="referralUrl" v-on:focus="copyReferralCodeUrl()" v-on:click="copyReferralCodeUrl()" data-toggle="tooltip" data-placement="top" title="Copied">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'
import _ from 'underscore'

export default {
  name: 'MyProfile',
  props: [],
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
  },
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone1: '',
      phone2: '',
      dob: '',
      sex: '',
      photo: '',
      address: {},
      creditPoint: undefined,
      referralCode: '',
      tick : false,
      referralUrl : '',
      credits : ''
    }
  },
  mounted () {
    this.getProfile()
    $('input[data-toggle="tooltip"]').tooltip({
        animated: 'fade',
        placement: 'top',
        trigger: 'manual'
    })
  },
  watch: {
    referralUrl: function() {
        // this.referralUrl = this.$signupUrl + this.$encryptString(this.referralCode.toLowerCase())
    }
  },
  methods: {
    copyReferralCodeUrl: function () {
      this.$refs.copyReferralText.select()
      document.execCommand("copy");
        $('input[data-toggle="tooltip"]').tooltip("show")
      setTimeout(function(){
          $('input[data-toggle="tooltip"]').tooltip("hide")
      }, 1000)
    },
    getProfile: function () {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {}
          Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                _.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address
                  }
                })
              }
              this.firstName = res.response.Patient.firstName
              this.lastName = res.response.Patient.lastName
              this.email = res.response.email
              this.phone1 = res.response.Patient.phone1
              this.phone2 = res.response.Patient.phone2
              this.dob = res.response.Patient.dob ? res.response.Patient.dob : ''
              this.sex = res.response.Patient.sex
              this.creditPoint = res.response.Patient.creditPoint
              this.referralCode = res.response.Patient.referralCode
              this.referralUrl = this.$signupUrl + this.$encryptString(this.referralCode)
              this.credits = res.response.credits

                let userDetails = {
                    'username': res.response.Patient.firstName + ' ' + res.response.Patient.lastName,
                    'firstName': res.response.Patient.firstName,
                    'lastName': res.response.Patient.lastName,
                    'photo': res.response.Patient.photo,
                    'dob': res.response.Patient.dob,
                    'phone1': res.response.Patient.phone1,
                    'phone2': res.response.Patient.phone2,
                    'sex': res.response.Patient.sex,
                    'email': res.response.email,
                    'credits': res.response.Patient.creditPoint
                }
                this.$localStorage.set('profile', userDetails, 0)
                this.$root.$emit('profileUpdated', true);
            }
            this.$hidePageLoading()
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error('method:getProfile', e)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/web/Secure/MyProfile.vue